module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f0750d_banner_800x600.89e1d99b.png";